module.exports = __webpack_public_path__ + "static/media/office.00936e99.svg";